export enum LobbyGameType {
  SPIN_MACHINE = 'SPIN_MACHINE',
  QUIZ = 'QUIZ',
  WHEEL = 'WHEEL',
  MULTI_WHEEL = 'MULTI_WHEEL',
  BOARD = 'BOARD',
}
